import { StaticJsonRpcProvider } from '@ethersproject/providers'
import { VESISConfig } from '~/types/config'
import { VotingEscrow, VotingEscrow__factory } from './types'

export function getVotingEscrowContract(
	config: VESISConfig,
	provider: StaticJsonRpcProvider
): VotingEscrow {
	return VotingEscrow__factory.connect(config.votingEscrowAddress, provider)
}
